import React from 'react';
import { shiftMetrics } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';
import { FiUsers, FiClock, FiTrendingUp, FiDollarSign } from 'react-icons/fi';

const MetricBox = ({ label, value, subtext, icon: Icon, alert }) => (
  <div className={`bg-chefDark border ${alert ? 'border-chiliRed shadow-glow-red' : 'border-chefPanel'} rounded-xl p-5 flex flex-col justify-between transition-all hover:translate-y-[-2px] h-full`}>
    <div className="flex items-start justify-between">
      <div className={`p-2.5 rounded-lg ${alert ? 'bg-chiliDark/50 text-chiliRed' : 'bg-chefPanel/50 text-receiptMuted'}`}>
        <SafeIcon icon={Icon} className="w-5 h-5" />
      </div>
      <div className={`text-[10px] font-mono px-2 py-0.5 rounded uppercase tracking-tighter ${alert ? 'bg-chiliRed/20 text-chiliRed' : 'bg-status-open/10 text-status-open'}`}>
        {alert ? 'Critical' : 'Nominal'}
      </div>
    </div>
    <div className="mt-4">
      <p className="text-receiptMuted text-[10px] font-mono uppercase tracking-[0.2em]">{label}</p>
      <div className="flex items-baseline gap-2 mt-1">
        <p className="text-receiptWhite text-3xl font-black">{value}</p>
        {subtext && <p className={`text-[10px] font-mono ${alert ? 'text-chiliRed' : 'text-receiptMuted'} opacity-70`}>{subtext}</p>}
      </div>
    </div>
  </div>
);

export const MetricsRow = () => {
  const turnAlert = parseInt(shiftMetrics.avgTurnTime) > parseInt(shiftMetrics.targetTurnTime);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <MetricBox label="Covers" value={shiftMetrics.covers} subtext={`/${shiftMetrics.targetCovers}`} icon={FiUsers} />
      <MetricBox label="Turn Time" value={shiftMetrics.avgTurnTime} subtext={turnAlert ? '+3m Target' : 'On track'} icon={FiClock} alert={turnAlert} />
      <MetricBox label="Waitlist" value={shiftMetrics.waitlist} subtext="Parties" icon={FiTrendingUp} />
      <MetricBox label="Net Rev" value={shiftMetrics.revenueEst} subtext="USD" icon={FiDollarSign} />
    </div>
  );
};